import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { showNotification } from '@epi-actions/overlays';
import emptyApi from '@epi-api/emptyApi';
import { get, put } from '@epi-helpers/FetchHelpers';
import { GET_COMPANY_METADATA_API_TAG } from '@epi-api/apiTags';
import {
  ICompanyMetadata,
  ICompanyMetadataUpdate
} from '@epi-models/core/Layout';
import { EndOfFundsPeriod } from '@epi-constants/errorName';
import { ApiError } from '@epi-helpers/ApiError';

import config from '../../config/config';

export const getCompanyMetadata = async (): Promise<ICompanyMetadata> =>
  get<ICompanyMetadata>(`${config.apiHost}/api/company-metadata`);

export const putCompanyMetadata = async (
  metadata: ICompanyMetadataUpdate
): Promise<ICompanyMetadataUpdate> =>
  put<ICompanyMetadataUpdate>(
    `${config.apiHost}/api/company-metadata`,
    metadata
  );

export const companyMetadataApi = emptyApi.injectEndpoints({
  endpoints: build => ({
    getMetadata: build.query<ICompanyMetadata, void>({
      async queryFn(_arg, api) {
        try {
          const data = await getCompanyMetadata();
          return { data };
        } catch (error) {
          api.dispatch(
            showNotification({ message: 'messages.error' }, 'error')
          );
          return { error: error as FetchBaseQueryError };
        }
      },
      keepUnusedDataFor: 1800,
      providesTags: [GET_COMPANY_METADATA_API_TAG]
    }),
    updateEndOfFundsPeriod: build.mutation<
      Pick<ICompanyMetadataUpdate, 'endOfFundsPeriod'>,
      number
    >({
      async queryFn(endOfFundsPeriod, api) {
        try {
          const data = await putCompanyMetadata({ endOfFundsPeriod });
          api.dispatch(
            showNotification(
              {
                message:
                  'containers.beneficiaries.tabs.settings.success_message'
              },
              'success'
            )
          );
          return { data };
        } catch (error) {
          if (
            error instanceof ApiError &&
            error.prop?.errors?.[0].fieldName === EndOfFundsPeriod
          ) {
            api.dispatch(
              showNotification(
                {
                  message: 'messages.end_of_funds_period'
                },
                'error'
              )
            );
          } else {
            api.dispatch(
              showNotification({ message: 'messages.error' }, 'error')
            );
          }
          return { error: error as FetchBaseQueryError };
        }
      },
      invalidatesTags: [GET_COMPANY_METADATA_API_TAG]
    })
  })
});

export const { useGetMetadataQuery, useUpdateEndOfFundsPeriodMutation } =
  companyMetadataApi;
